import React from 'react';
import { Button, Box, Typography, Card, CardContent, Avatar, Stack, Divider } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import WidgetFormDialog from 'src/widgets/WidgetFormDialog';
import WidgetFormTextField from 'src/widgets/WidgetFormTextField';
import WidgetAlert from 'src/widgets/WidgetAlert';
import WidgetSelect from 'src/widgets/WidgetSelect';
import useAddUser from 'src/hooks/useAddUser';

const AddUser = ({ roles, dataUsers, getUsers }) => {
    const {
        open,
        handleOpen,
        handleClose,
        form,
        setForm,
        tipoUsuarioOptions,
        rolOptions,
        onSave,
        alert,
        closeAlert,
        showClientField
    } = useAddUser(roles, dataUsers, getUsers);

    return (
        <>
            <Button
                variant="contained"
                onClick={handleOpen}
                startIcon={<PersonAddIcon />}
                sx={{
                    textTransform: 'none',
                    fontWeight: 700,
                    borderRadius: 2,
                    px: 2.5,
                    py: 1,
                    boxShadow: '0 8px 24px rgba(16,24,40,0.08)',
                    '&:hover': { transform: 'translateY(-2px)' }
                }}
            >
                Agregar usuario
            </Button>

            <WidgetFormDialog open={open} title="Agregar Usuario" onClose={handleClose} onAccept={onSave}>
            <Card elevation={0} sx={{ borderRadius: 3 }}>
                <CardContent sx={{ p: { xs: 2, md: 3 }, background: 'linear-gradient(180deg,#fff,#fbfdff)' }}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
                        <Avatar sx={{ bgcolor: 'transparent', width: 44, height: 44 }}>
                            <PersonAddIcon sx={{ color: 'primary.main' }} />
                            </Avatar>
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 800 }}>Nuevo usuario</Typography>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>Completa los campos para crear el usuario</Typography>
                            </Box>
                        </Box>

                        <Box component="form" sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                            <Box sx={{ gridColumn: '1 / -1' }}>
                                <WidgetSelect
                                    label="Tipo usuario *"
                                    value={form.TIPOUSUARIO}
                                    onChange={(e) => setForm({ ...form, TIPOUSUARIO: e.target.value })}
                                    options={tipoUsuarioOptions}
                                />
                            </Box>

                            {showClientField && (
                                <Box sx={{ gridColumn: '1 / -1' }}>
                                    <WidgetFormTextField
                                        label="ID Cliente *"
                                        value={form.IDCLIENTE}
                                        onChange={(e) => setForm({ ...form, IDCLIENTE: e.target.value })}
                                        required
                                    />
                                </Box>
                            )}

                            <Box>
                                <WidgetFormTextField
                                    label="Username *"
                                    value={form.userName}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            userName: e.target.value.replace(/\s/g, '')
                                        })
                                    }
                                    required
                                />
                            </Box>

                            <Box>
                                <WidgetFormTextField
                                    label="Email *"
                                    type="email"
                                    value={form.email}
                                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                                    required
                                />
                            </Box>

                            <Box>
                                <WidgetFormTextField
                                    label="Nombre *"
                                    value={form.name}
                                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                                    required
                                />
                            </Box>

                            <Box>
                                <WidgetFormTextField
                                    label="Apellido"
                                    value={form.lastName}
                                    onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                                />
                            </Box>

                            <Box sx={{ gridColumn: '1 / -1' }}>
                                <WidgetSelect
                                    label="Rol *"
                                    value={form.rolID}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            rolID: e.target.value,
                                            rolName: roles.find(r => r.ID === e.target.value)?.NAME || ''
                                        })
                                    }
                                    options={rolOptions}
                                />
                            </Box>

                            <Box sx={{ gridColumn: '1 / -1', mt: 1 }}>
                                <Divider sx={{ my: 1 }} />
                                <Typography variant="caption">Password inicial: <strong>icintracom</strong>. Se pedirá cambiarlo al iniciar sesión.</Typography>
                            </Box>

                        </Box>
                    </CardContent>
                </Card>
            </WidgetFormDialog>

            <WidgetAlert {...alert} onClose={closeAlert} />
        </>
    );
};

export default AddUser;